export default __webpack_public_path__ + "static/media/MySQL.c568b666.svg";